import type { ReactNode } from 'react';

export function FormattedMessage({ content }: { content: string }) {
  if (!content) return null;

  const lines = content.split('\n');
  const elements: ReactNode[] = [];
  let bulletGroup: string[] = [];

  const flushBullets = () => {
    if (bulletGroup.length > 0) {
      elements.push(
        <ul key={`bl-${elements.length}`} className="message-bullet-list">
          {bulletGroup.map((b, i) => <li key={i}>{b}</li>)}
        </ul>
      );
      bulletGroup = [];
    }
  };

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const bulletMatch = line.match(/^\s*[•\-]\s+(.*)$/);
    if (bulletMatch) {
      bulletGroup.push(bulletMatch[1]);
    } else {
      flushBullets();
      const trimmed = line.trim();
      if (trimmed === '') {
        if (elements.length > 0) {
          elements.push(<div key={`sp-${i}`} className="message-spacer" />);
        }
      } else {
        elements.push(<p key={`p-${i}`} className="message-paragraph">{trimmed}</p>);
      }
    }
  }
  flushBullets();

  return <>{elements}</>;
}
